import { useGetDataQuery } from "common/commonRedux/getRTKApi/baseApi";
import { useSelector } from "react-redux";

interface Clients {
    employeeName: string,
    employeeId: string | null,
    employeeEmail: string,
}
export const useAllClients = (): { clients: Clients[], refetchClients: any, isFetching: boolean, } => {
    const { accountid } = useSelector((state: any) => {
        return state.auth?.profileData.tokenData
    })
    const { data: clients = [], refetch: refetchClients, isFetching } = useGetDataQuery({ params: { accountId: accountid }, urlObjKey: 'GetEmployeeFilters', }, { skip: accountid === undefined })
//  console.log('All Clients:', clients);
    return { clients, refetchClients, isFetching };
};
